module.exports = __webpack_public_path__ + "static/media/19ESCAP37.e228be40.jpg";